<template>Redirecting..</template>

<script lang="ts" setup>
import { useWorktreeManager } from "@/composables/worktree-manager";
import { watch } from "vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();
const { worktree } = useWorktreeManager();
const { processName, productName, domainName } = route.params;

watch(
    worktree,
    () => {
        if (worktree.value) {
            redirect();
        }
    },
    { immediate: true }
);

const redirect = () => {
    if (processName) {
        for (const domain of worktree.value.domains) {
            for (const product of domain.products) {
                for (const process of product.processes) {
                    if (process.name === processName) {
                        router.push({
                            name: "processPage",
                            params: {
                                orgName: route.params.orgName,
                                stekName: route.params.stekName,
                                processId: process.identity,
                            },
                        });
                        return;
                    }
                }
            }
        }
    }

    if (productName) {
        for (const domain of worktree.value.domains) {
            for (const product of domain.products) {
                if (product.name === productName) {
                    router.push({
                        name: "productPage",
                        params: {
                            orgName: route.params.orgName,
                            stekName: route.params.stekName,
                            productId: product.identity,
                        },
                    });
                    return;
                }
            }
        }
    }

    if (domainName) {
        for (const domain of worktree.value.domains) {
            if (domain.name === domainName) {
                router.push({
                    name: "domainPage",
                    params: {
                        orgName: route.params.orgName,
                        stekName: route.params.stekName,
                        domainId: domain.identity,
                    },
                });
                return;
            }
        }
    }

    // Couldn't find anything, so lets just redirect to a 'not found' page.
    router.push({
        name: "not-found",
        params: {
            orgName: route.params.orgName,
            stekName: route.params.stekName,
        },
        query: {
            type: productName ? "product" : "domain",
            name: productName || domainName,
        },
    });
};
</script>

<style></style>
